/**
 * C-44 «Идёт звонок» — полоса над экраном (изменение v1.14).
 *
 * Как зелёная полоса Telegram: звонок свёрнут, а приложение доступно целиком; нажатие
 * возвращает экран звонка. Если звонок этого устройства ведёт другая вкладка, полоса говорит
 * об этом — там же и завершить его.
 */
import { callTimerLabel } from '@entities/call/labels'
import { deviceCallOf, useOpenCalls } from '@entities/call/model'
import { useCallStore } from '@features/calls/store'
import { Icon, cx } from '@shared/ui'

import { useAppStore } from '../../model/app-store'
import { useCallSeconds } from './use-call-seconds'
import { useCallPeer } from './use-call-peer'
import styles from './call.module.css'

function OwnCallBar() {
  const view = useCallStore((s) => s.view)
  const setMinimized = useCallStore((s) => s.setMinimized)
  const peer = useCallPeer(view?.conversationId ?? null)
  const seconds = useCallSeconds(view?.connectedAt ?? null)
  if (!view || view.phase === 'ended') return null
  const state =
    view.phase === 'active'
      ? callTimerLabel(seconds)
      : view.phase === 'reconnecting'
        ? 'восстанавливаем связь…'
        : 'соединение…'
  return (
    <button
      type="button"
      className={cx(styles['bar'], view.muted && styles['barMuted'])}
      onClick={() => setMinimized(false)}
      data-call-bar
    >
      <Icon name={view.muted ? 'mic-off' : 'phone'} size={16} />
      <span className={styles['barText']}>
        {peer.name} · {state}
      </span>
      <span aria-hidden="true">›</span>
    </button>
  )
}

function OtherTabBar() {
  const deviceId = useAppStore((s) => s.me?.user.device_id ?? null)
  const calls = useOpenCalls()
  const call = deviceCallOf(calls, deviceId)
  // Свой звонок вкладка показывает своей полосой (CallBar выбирает её по view), сюда он не доходит.
  if (!call) return null
  return (
    <div className={cx(styles['bar'], styles['barMuted'])} role="status">
      <Icon name="phone" size={16} />
      <span className={styles['barText']}>Звонок идёт в другой вкладке</span>
    </div>
  )
}

/** Полоса в потоке колонки над экраном: не перекрывает шапку, а сдвигает её. */
export function CallBar() {
  const minimized = useCallStore((s) => s.minimized)
  const hasView = useCallStore((s) => s.view !== null)
  if (hasView) return minimized ? <OwnCallBar /> : null
  return <OtherTabBar />
}
